export default "__VITE_ASSET__Bi2BErxg__"